import React from 'react';
import './LoadVisibility.scss';
import { useAnimateOnScroll } from '../../Utils/hooks/useAnimateOnScroll';

import truckImageWebp from '../../Assets/images/load_visibility_main_truck.webp';
import truckImage from '../../Assets/images/load_visibility_main_truck.png';
import statusIcon from '../../Assets/images/load_visibility_status.png';
import dispatchIcon from '../../Assets/images/load_visibility_dispatch.png';
import materialIcon from '../../Assets/images/load_visibility_material.png';
import verificationIcon from '../../Assets/images/load_visibility_verification.png';

const features = [
  {
    id: 'status',
    icon: statusIcon,
    width: 40,
    height: 40,
    alt: 'Real-Time Load Status Updates icon',
    label: 'Real-Time Load Status Updates',
  },
  {
    id: 'dispatch',
    icon: dispatchIcon,
    width: 41,
    height: 36,
    alt: 'Dispatch-to-Delivery Tracking icon',
    label: 'Dispatch-to-Delivery Tracking',
  },
  {
    id: 'material',
    icon: materialIcon,
    width: 38,
    height: 38,
    alt: 'Material Delivery Confirmation icon',
    label: 'Material Delivery Confirmation',
  },
  {
    id: 'verification',
    icon: verificationIcon,
    width: 40,
    height: 40,
    alt: 'Verified Delivery Timeline icon',
    label: 'Verified Delivery Timeline',
  },
];

const LoadVisibility = () => {
  const sectionRef = useAnimateOnScroll();
  const textRef = useAnimateOnScroll();
  const imageRef = useAnimateOnScroll();

  return (
  <section ref={sectionRef} className="load-visibility slide-up">
    <div className="container load-visibility__inner">
    <div ref={textRef} className="load-visibility__col-text left-in">
      <h2 className="load-visibility__title">
        Real-Time Load{' '}
        <span className="load-visibility__title-highlight">Visibility</span>
      </h2>

      <p className="load-visibility__description">
        Stay fully informed from dispatch to delivery. Track load progress in
        real time, confirm material delivery, and access verified timelines —
        all in one streamlined system.
      </p>

      <ul className="load-visibility__features">
        {features.map((feature) => (
          <li key={feature.id} className="load-visibility__feature-item">
            <img
              src={feature.icon}
              alt={feature.alt}
              className="load-visibility__feature-icon"
              width={feature.width}
              height={feature.height}
            />
            <span className="load-visibility__feature-label">
              {feature.label}
            </span>
          </li>
        ))}
      </ul>
    </div>

    <div ref={imageRef} className="load-visibility__col-image scale-in">
      <picture>
        <source srcSet={truckImageWebp} type="image/webp" />
        <img
          src={truckImage}
          alt="Heavy haul truck in tunnel"
          className="load-visibility__truck-img"
          width="699"
          height="699"
        />
      </picture>
    </div>
    </div>
  </section>
  );
};

export default LoadVisibility;
